/**
 * The single, always-visible clock to the Bank's 3 PM cut-off — the game's one source of time
 * pressure. Counts DOWN in timed mode; UP in untimed/practice mode. Tone escalates inside 5 minutes
 * and pulses (motion-safe only) inside 2. role="timer" with aria-live off so it doesn't spam screen
 * readers every second (WCAG 2.2.2 — the run can also be played untimed).
 */
import { Clock as ClockIcon } from "lucide-react";
import { cx, formatClock } from "../lib/ui";

export function Clock({
  elapsedMs,
  limitMs,
  mode,
}: {
  elapsedMs: number;
  limitMs: number;
  mode: "timed" | "untimed";
}) {
  const timed = mode === "timed";
  const remaining = Math.max(0, limitMs - elapsedMs);
  const minutesLeft = remaining / 60_000;
  const urgent = timed && minutesLeft <= 5;
  const critical = timed && minutesLeft <= 2;
  return (
    <div
      role="timer"
      aria-live="off"
      aria-label={timed ? "Time to cut-off" : "Elapsed time"}
      className={cx(
        "inline-flex items-center gap-2 rounded-sm border px-3 py-1.5 font-mono text-sm tabular-nums",
        critical ? "border-brand text-brand" : urgent ? "border-brand/60 text-brand" : "border-ink-200 text-ink",
        critical && "motion-safe:animate-pulse",
      )}
    >
      <ClockIcon size={16} strokeWidth={2} aria-hidden="true" />
      <span>{formatClock(timed ? remaining : elapsedMs)}</span>
      {timed && (
        <span className="text-xs text-ink-500" aria-hidden="true">
          to cut-off
        </span>
      )}
    </div>
  );
}
